/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Companydetailstitle2Inputs */

const en_companydetailstitle2 = /** @type {(inputs: Companydetailstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Billing details`)
};

const de_companydetailstitle2 = /** @type {(inputs: Companydetailstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rechnungsdaten`)
};

/**
* | output |
* | --- |
* | "Billing details" |
*
* @param {Companydetailstitle2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const companydetailstitle2 = /** @type {((inputs?: Companydetailstitle2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Companydetailstitle2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_companydetailstitle2(inputs)
	return de_companydetailstitle2(inputs)
});
export { companydetailstitle2 as "companyDetailsTitle" }